<style lang="scss" scoped>
.tile {
	cursor: pointer;
	margin-bottom: 20px;
	&__body {
		@include flex-center;
	}
	h3 {
		margin-left: 20px;
		font-size: 22px;
		line-height: 23px;
		margin-bottom: 0;
	}
}
</style>


<template lang="pug">
.tile(@click="navigateToClass()")
    el-card()
        .tile__body
            class-icon(:icon="classroom.Icon", :size="80")
            h3 {{ classroom.name }}
</template>

<script>
import ClassIcon from "@/components/classroom/ClassIcon";

export default {
	components: {
		ClassIcon
	},

	props: {
		classroom: {
			type: Object,
			required: true
		}
	},

	methods: {
		navigateToClass() {
			this.$router.push({ name: "classroom.show", params: { class: this.classroom.id } });
		}
	}
};
</script>




// WEBPACK FOOTER //
// src/components/apps/appsList/cards/ClassroomTile.vue